import { uriMatcher } from "@megaron/uri";

import { invoiceThreadFiltersSerializer } from "./invoiceThreadFilters";
import { megaraxUriSchema } from "./uri";

export const getMegaraxPath = uriMatcher(megaraxUriSchema)<string>({
  "megarax://home": () => "/",
  "megarax://test-doc/{id}": ({ id }) => `/test-doc/${id}`,

  "megarax://crm/customers": () => "/crm/customers",
  "megarax://crm/customers/new": () => "/crm/customers/new",
  "megarax://crm/customer-list/{id}": ({ id }) => `/crm/customers/${id}`,
  "megarax://crm/customer/{id}": ({ id }) => `/crm/customer/id/${id}`,

  "megarax://crm/orders": () => "/crm/orders",
  "megarax://crm/order/{number}": ({ number }) => `/crm/orders/${number}`,

  "megarax://crm/order-drafts": () => "/crm/order-drafts",
  "megarax://crm/order-draft/{id}": ({ id }) => `/crm/order-drafts/${id}`,

  "megarax://crm/my-visits": () => "/crm/pos/moje_wizyty",
  "megarax://crm/visits/{id}": ({ id, date, view }) =>
    `crm/pos/handlowcy/${id}/wizyty/${{ week: "tydzien", day: "dzien" }[view]}/${date}`,

  "megarax://crm/regions": () => "/crm/regions",
  "megarax://crm/region/{id}": ({ id }) => `/crm/regions/${id}`,

  "megarax://crm/trade-routes": () => "/crm/pos/trasy",
  "megarax://crm/trade-route/{id}": ({ id }) => `crm/pos/trasy/${id}`,

  "megarax://crm/price-reports": () => "/crm/pos/moje_ankiety_cenowe",
  "megarax://crm/price-report-products": () => "/crm/pos/ankiety_cenowe/produkty",

  "megarax://crm/home": () => "/crm/user-home",
  "megarax://crm/post-sale-discounts": () => "/crm/post-sale-discounts",
  "megarax://crm/profit-targets": () => "/crm/profit-targets",
  "megarax://crm/my-affiliate-codes": () => "/crm/my-affiliate-codes",
  "megarax://crm/product-availability": () => "/crm/product-availability",
  "megarax://crm/training-calendar": () => "/crm/training",

  "megarax://catalog/items": () => "/crm/items",
  "megarax://catalog/item/{id}": ({ id }) => `/crm/items/${id}`,
  "megarax://catalog/price-lists": () => "/crm/pos/cenniki",
  "megarax://catalog/price-list/{id}": ({ id }) => `/crm/pos/cenniki/${id}`,

  "megarax://invoices/thread/{id}": ({ id }) => `/faktury/watki/${id}`,
  "megarax://invoices/threads": ({ filters }) => {
    let url = `/faktury/watki`;
    if (filters) {
      const filtersStr = invoiceThreadFiltersSerializer.asJsonString().serialize(filters);
      url += `?filters=${filtersStr}`;
    }
    return url;
  },
  "megarax://invoices/budget/{id}": ({ id }) => `/faktury/budzety/${id}`,
  "megarax://invoices/budgets": () => "/faktury/budzety",
  "megarax://invoices/draft/{id}": ({ id }) => `/faktury/wersje-robocze/${id}`,
  "megarax://invoices/drafts": () => "/faktury/wersje-robocze",

  "megarax://iam/user/{id}": ({ id }) => `/iam/accounts/email/${id}`,
  "megarax://iam/users": () => "/iam/accounts",
  "megarax://iam/group/{id}": ({ id }) => `/iam/groups/id/${id}`,
  "megarax://iam/groups": () => "/iam/groups",

  "megarax://support/ticket/{id}": ({ id }) => `/support/tickets/${id}`,
  "megarax://support/tickets": () => "/support/tickets",
  "megarax://support/settings": () => "/support/settings",

  "megarax://loyalty/lines": () => "/specjalista/batches",
  "megarax://loyalty/line/{id}": ({ id }) => `/specjalista/qr-sync/line/${id}`,
  "megarax://loyalty/batches": () => "/specjalista/batches",
  "megarax://loyalty/production-batch/{id}": ({ id }) => `/specjalista/batches/production-batch/${id}`,
  "megarax://loyalty/label-batch/{id}": ({ id }) => `/specjalista/batches/label-batch/${id}`,

  "megarax://saved-view/{id}": ({ id }) => `/saved-views/${id}`,

  "megarax://dev/docs": () => "/dev/docs",
  "megarax://dev/notifications": () => "/dev/notifications",
  "megarax://dev/environment": () => "/dev/environment",

  "megarax://loyalty/accounts": () => "/specjalista/accounts",
  "megarax://loyalty/blik-checks": () => "/specjalista/blik-checks",
  "megarax://loyalty/carts": () => "/specjalista/carts",
  "megarax://loyalty/code-groups": () => "/specjalista/product-codes/groups",
  "megarax://loyalty/inspect-code": () => "/specjalista/inspect-code",
  "megarax://loyalty/listings": () => "/specjalista/listings",
  "megarax://loyalty/order-fulfillment": () => "/specjalista/order-fulfillment",
});
